import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render supporting documents section for FAQ Page
 */
const SupportingDocumentsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans leading-[1.4]"
      data-testid="supporting-documents-section-component"
    >
      <AccordionV2
        testId="supporting-documents"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="4. Do I have to submit any supporting documents with the application form?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0">
          <p className="mt-3">
            The application form must be accompanied by financial statements for
            the last two financial years† and the business must fulfil the
            following criteria:
          </p>

          <p className="mb-0">
            <strong>• Years of business operation</strong>
          </p>
          <p>
            - (For Emerging Enterprise Award and Emerging Enterprise
            Sustainability Award) Up to 10 years
            <br />- (For Most Promising Startup Award and Most Promising
            Sustainability Startup Award) Up to 5 years
          </p>

          <p>
            <strong>• Business incorporation: </strong> Registered either as a
            Sole Proprietor, Partnership, Limited Partnership, Limited Liability
            Partnership, or Private Limited. Not applicable to (1) a lending
            institution or an affiliate of such lending institution, (2) a
            listed company or (3) a company which has submitted an application
            for its shares to be listed for quotation on the official list of a
            securities exchange as defined in the Securities and Futures Act
            2001 on or before the physical presentation of the Emerging
            Enterprise Award or the Emerging Enterprise Sustainability Award or
            the Most Promising Startup Award or the Most Promising
            Sustainability Startup Award at an event organised by the
            organisers/sponsors. Note: For applicants from Indonesia, your
            business must be registered either as a Limited Liability Company
            (Perseroan Terbatas or PT) or Limited Liability Partnership
            (Commanditaire Vennonntschap or CV)
          </p>

          <p>
            <strong>
              • Annual sales turnover as of the last financial year:
            </strong>
            Up to SGD 20 million or local currency equivalent
          </p>

          <p className="mb-0">
            <strong>• Business profile</strong>
          </p>

          <p className="mb-0">
            <strong>
              Have a business profile that is filed with your country’s official
              regulator of business entities, examples:
            </strong>
          </p>

          <p className="mb-0">
            • Singapore: Business profile with Accounting and Corporate
            Regulatory Authority (ACRA)
          </p>

          <p className="mb-0">
            • Malaysia: Business profile with Companies Commission of Malaysia
            (CCM) or Suruhanjaya Syarikat Malaysia (SSM)
          </p>

          <p className="mb-0">
            • Indonesia: Company Registration Certificate (TDP) or NIB or
            Trading Business License (SIUP) or similar document
          </p>

          <p className="mb-0">
            • Hong Kong: Certificate of Incorporation or Business Registration
            Certificate
          </p>

          <p className="mt-5">
            <strong>• Financial documentation: </strong>Latest financial
            statements for the last two financial years, including management
            statements.
          </p>

          <p className="pb-8">
            †For businesses that have only 1 year of operation, financial
            statements can be for the prior or current year, whichever is
            available.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default SupportingDocumentsSection;
